export const API_PATH_ApiAlertMgtmCreateTestAlert = '/services/alert-mgtm/apiAlertMgtmCreateTestAlert';
export var ECreateTestAlert;
(function (ECreateTestAlert) {
    ECreateTestAlert["DEMO_HEAVY_SNOWFALL"] = "DEMO_HEAVY_SNOWFALL";
})(ECreateTestAlert || (ECreateTestAlert = {}));
